import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@app/shared';
import {TieuChuanComponent} from '@entities/tieu-chuan/tieu-chuan/tieu-chuan.component';
import {
  TieuChuanDialogComponent,
  TieuChuanPopupComponent,
} from '@entities/tieu-chuan/tieu-chuan-dialog/tieu-chuan-dialog.component';
import {TieuChuanRoute} from '@entities/tieu-chuan/tieu-chuan.route';
import {RouterModule, Routes} from '@angular/router';
import {TieuChuanDetailComponent} from '@entities/tieu-chuan/tieu-chuan-detail/tieu-chuan-detail.component';
import {
  TieuChuanDeleteDialogComponent,
  TieuChuanDeletePopupDiaglogComponent,
} from '@entities/tieu-chuan/tieu-chuan-delete-dialog/tieu-chuan-delete-dialog.component';
import {
  TieuChuanDeleteDateDialogComponent,
  TieuChuanDeleteDatePopupDiaglogComponent,
} from '@entities/tieu-chuan/tieu-chuan-delete-date-dialog/tieu-chuan-delete-date-dialog.component';
import {
  GiaiDoanDialogComponent,
  GiaiDoanPopupComponent,
} from '@entities/tieu-chuan/giai-doan-dialog/giai-doan-dialog.component';
import {
  GiaiDoanDeletePopupDiaglogComponent,
  GiaiDoanDeleteDialogComponent,
} from '@entities/tieu-chuan/giai-doan-delete-dialog/giai-doan-delete-dialog.component';
import {
  NgayTuoiDialogComponent,
  NgayTuoiPopupComponent,
} from '@entities/tieu-chuan/ngay-tuoi-dialog/ngay-tuoi-dialog.component';
import {
  ActivityTypePopupComponent,
  ActivityTypeDialogComponent,
} from '@entities/tieu-chuan/activity-type-dialog/activity-type-dialog.component';
import {
  ActivityTypeDeleteDialogComponent,
  ActivityTypeDeletePopupDialogComponent,
} from '@entities/tieu-chuan/activity-type-delete-dialog/activity-type-delete-dialog.component';
import {
  NgayTuoiDuplicateDialogComponent,
  NgayTuoiDuplicatePopupComponent,
} from '@entities/tieu-chuan/ngay-tuoi-duplicate-dialog/ngay-tuoi-duplicate-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
// Removed NgxMatDatetimePickerModule and NgxMatMomentModule imports
const ENTITY_STATES = [...TieuChuanRoute];

@NgModule({
  declarations: [
    TieuChuanComponent,
    TieuChuanDialogComponent,
    TieuChuanPopupComponent,
    TieuChuanDetailComponent,
    TieuChuanDeleteDialogComponent,
    TieuChuanDeletePopupDiaglogComponent,
    TieuChuanDeleteDateDialogComponent,
    TieuChuanDeleteDatePopupDiaglogComponent,
    GiaiDoanDialogComponent,
    GiaiDoanPopupComponent,
    GiaiDoanDeletePopupDiaglogComponent,
    GiaiDoanDeleteDialogComponent,
    NgayTuoiDialogComponent,
    NgayTuoiPopupComponent,
    ActivityTypePopupComponent,
    ActivityTypeDialogComponent,
    ActivityTypeDeleteDialogComponent,
    ActivityTypeDeletePopupDialogComponent,
    NgayTuoiDuplicateDialogComponent,
    NgayTuoiDuplicatePopupComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ENTITY_STATES as Routes),
    MatDatepickerModule,
  ],
  entryComponents: [
    TieuChuanDialogComponent,
    TieuChuanDeleteDialogComponent,
    TieuChuanDeleteDateDialogComponent,
    GiaiDoanDialogComponent,
    GiaiDoanDeleteDialogComponent,
    NgayTuoiDialogComponent,
    ActivityTypeDialogComponent,
    ActivityTypeDeleteDialogComponent,
    NgayTuoiDuplicateDialogComponent,
  ],
})
export class TieuChuanModule {}
